import React from "react";
import PropTypes from "prop-types";
import { withClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "../css/styles.css";
const SkipToContent = _ref => {
  let {
    classes,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("a", {
    className: classes['skip-to-content'],
    href: `#${props.mainContentId}`
  }, "Skip to Main Content");
};
process.env.NODE_ENV !== "production" ? SkipToContent.propTypes = {
  /**
   * Children
   */
  mainContentId: PropTypes.string,
  /**
   * Classes dependencies
   */
  classes: classesPropType(['skip-to-content'])
} : void 0;
export default withClasses(styles)(SkipToContent);